// TODO: This is the flow template every component should use -
// we should refactor any that are not using it, or remove old components

export const flows = {
    flow_c: {
        version: "flow_c",
        pages: [
            "GlutenSensitivity1",
            "AtlyIntro1",
            'EmailScreen2',
            "DietaryRestrictions",
            'TagsStatement',
            "SearchTarget",
            // "CommunityValidationStatement",
            "FeaturePreference",
            "SafetyRankingExplanation",
            "SafetyRankingStatement",
            "InformationSources",
            "ReviewAggregationStatement",
            "WhatPlacesDoYouWant1",
            "InformationAccuracyQuestion",
            "InformationUpdateStatement",
            //"SafetyCommitmentStatement",
            "CommunityMap",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButton",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSlider"
        }
    },
    flow2_e: {
        version: "flow2_e",
        pages: [
            'EmailScreen2',
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonUriel",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtly"
        }
    },
    flow2_e2: {
        version: "flow2_e2",
        pages: [
            'EmailScreen2',
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonUriel",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtlyNoClose"
        }
    },
    flow2_emailAtEnd: {
        version: "flow2_emailAtEnd",
        pages: [
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            //"WeDoAllThat"
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            'EmailScreen3',
            "Loading1",
            //"PerfectFit1",
            "PreCheckout",
            //HERE
            //"FeaturePreference",
            //"InformationSources",
            //"ReviewAggregationStatement",
            //"InformationAccuracyQuestion",
            //"InformationUpdateStatement",
            //"SafetyCommitmentStatement",
            //"CommunityMap",
            //"PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonUriel2",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtly2"
        }
    },
    flow2_f: {
        version: "flow2_f",
        pages: [
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            //"WeDoAllThat"
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            'EmailScreen3',
            "Loading1",
            //"PerfectFit1",
            "PreCheckout",
            //HERE
            //"FeaturePreference",
            //"InformationSources",
            //"ReviewAggregationStatement",
            //"InformationAccuracyQuestion",
            //"InformationUpdateStatement",
            //"SafetyCommitmentStatement",
            //"CommunityMap",
            //"PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonUriel2",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtly"
        }
    },
    flow_testimonial: {
        version: "flow_testimonial",
        pages: [
            'EmailScreen2',
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonial",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_a: {
        version: "flow_testimonial",
        pages: [
            "EmailScreen2",
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "PreCheckoutImproved",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_b: {
        version: "flow_testimonial",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "PreCheckoutImproved",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_c: {
        version: "flow_testimonial",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    web2app_testimonial_flow: {
        version: "web2app_testimonial_flow",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "InAppQuizResultsScreen",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_april: {
        version: "testimonial_april",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_april_gfe1b: {
        version: "testimonial_april_gfe1b",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_april_gfe1b_test: {
        version: "testimonial_april_gfe1b_test",
        pages: [
            "PerfectFit1",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    web2app_aprilpasta: {
        version: "web2app_aprilpasta",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "LoadingImproved",
            "PerfectFit1",
            "InAppQuizResultsScreen",
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    aprilburger: {
        version: "aprilburger",
        pages: [
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1", "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "AprilPricingPage"
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    aprilburger_test: {
        version: "aprilburger_test",
        pages: [
            "PerfectFit1",
            "AprilPricingPage"
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    testimonial_april_test: {
        version: "testimonial_april_test",
        pages: [
            "PerfectFit1",
            "AprilPricingPage"
        ],
        components: {
            drawerButton: "DrawerButtonTestimonialImproved",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "TestimonialStartPage"
        }
    },
    tt_april_testimonial: {
        version: "tt_april_testimonial",
        pages: [
            "SearchTarget",
            "SafetyOfPlaces1",
            "SafetyRankingStatement",
            "SafetyRankingExplanation",
            "BiggestStruggles1",
            "DietaryRestrictions",
            'TagsStatement',
            "WhereDoYouWantPlaces",
            "WhatPlacesDoYouWant1",
            "Statement230kPlaces2",
            "Loading1",
            "PerfectFit1",
            "PaymentPageRedirect",
        ],
        components: {
            drawerButton: "DrawerButtonUriel",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderAtly"
        }
    },
};
